"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboQuality = getComboQuality;
const ALMOST_NO_EMPTY_DISTANCE = 0.03;
const VERY_GOOD_SAVINGS_PERCENTAGE = 32;
const MEDIOCRE_SAVINGS_PERCENTAGE = 20;
function getComboQuality({ savingsPercentage, hasAdditionalCosts, comboEmptyDistanceCoefficient, }) {
    if (savingsPercentage >= VERY_GOOD_SAVINGS_PERCENTAGE &&
        comboEmptyDistanceCoefficient < ALMOST_NO_EMPTY_DISTANCE &&
        !hasAdditionalCosts) {
        return "best";
    }
    if (savingsPercentage >= MEDIOCRE_SAVINGS_PERCENTAGE) {
        return "mediocre";
    }
    return "worst";
}
//# sourceMappingURL=getComboQuality.js.map